/**
 * Copyright (c) 2025 Bytedance Ltd. and/or its affiliates
 * SPDX-License-Identifier: MIT
 */

import React from 'react';

export const FormModelContext = React.createContext<any>({});
export const FieldModelContext = React.createContext<any>({});
